import * as Stitches from '@stitches/react';
import { styled } from '@gbm-tech/styles';

const PageItemContainerHover: Stitches.CSS = {
  backgroundColor: '#eceef2',
};

const PageItemContainerLG: Stitches.CSS = {
  gap: '1.2rem',
};

const PageItemContainerXL: Stitches.CSS = {
  gap: '1.4rem',

  span: {
    fontSize: '1.8rem',
    lineHeight: '3.2rem',
  },
};

const PageItemContainerXXL: Stitches.CSS = {
  gap: '1.6rem',
};

export const PageItemContainer = styled('a', {
  padding: '1.2rem 1.6rem 1.2rem 2.2rem',

  display: 'flex',
  alignItems: 'center',
  gap: '1rem',

  border: 'none',
  outline: 'none',
  backgroundColor: 'white',

  textDecoration: 'none',

  cursor: 'pointer',
  transition: 'all ease-in-out 0.4s',

  '> span': {
    flex: 1,

    textAlign: 'left',
    fontSize: '1.6rem',
    lineHeight: '2.8rem',
    fontWeight: 400,

    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',

    color: '#404a59',
  },

  '&:hover': { ...PageItemContainerHover },

  '@lg': { ...PageItemContainerLG },

  '@xl': { ...PageItemContainerXL },

  '@xxl': { ...PageItemContainerXXL },
});
